import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseService} from './base.service';
import {Observable} from 'rxjs';
import {AlertService} from './alert.service';
import {GlobalService} from './global.service';
import {AppUrl} from '../constants/app-url';

@Injectable({
    providedIn: 'root'
})

export class UniversitySettingService extends BaseService {
    constructor(public http: HttpClient,
                public alertService: AlertService,
                public globalService: GlobalService) {
        super(http, alertService, globalService);
    }

    get(data): Observable<any> {
        return this.getRequest(AppUrl.UNIVERSITY_SETTINGS(), data);
    }

    detail(id): Observable<any> {
        return this.getRequest(AppUrl.UNIVERSITY_SETTINGS(id));
    }

    create(data): Observable<any> {
        return this.postRequest(AppUrl.UNIVERSITY_SETTINGS(), data);
    }

    update(id, data): Observable<any> {
        return this.putRequest(AppUrl.UNIVERSITY_SETTINGS(id), data);
    }

    updateStatus(id, data): Observable<any> {
        return this.putRequest(AppUrl.UNIVERSITY_SETTINGS_STATUS(id), data);
    }
}
